import { renderInDocument } from '@spotahome/bff/client';

import HelloWorld from './main';

renderInDocument(HelloWorld);
